import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';
import React, { Fragment, useEffect, useState } from 'react';
import LabelDetail from '../LabelDetail';
import { teamSettingsApi } from '@/_services/api/teamSettings';
import { connect } from 'react-redux';
import { setEditTeam } from '@/_redux';

const Component = React.memo(({ labels, teamId, setEditTeam }) => {
    const [isBusy, setIsBusy] = useState(false);
    const [teamVisitLabels, setTeamVisitLabels] = useState({});
    console.log({ labels });
    useEffect(() => {
        const fetchCustomVisitLabels = async () => {
            try {
                if (!teamId || isBusy) return;
                setIsBusy(true);
                const settings = await teamSettingsApi.getTeamSettings(teamId);
                setTeamVisitLabels(settings?.visitLabels || {});
                setEditTeam({
                    id: teamId,
                    settings,
                });
            } catch (e) {
                console.error('Error fetching custom visit labels', e);
            } finally {
                setIsBusy(false);
            }
        };
        fetchCustomVisitLabels();
    }, [teamId]);

    if (!labels) {
        return null;
    }
    return (
        <Fragment>
            {Object.keys(labels).map((labelKey) => (
                <LabelDetail key={labelKey} label={teamVisitLabels[labelKey] || labelKey} color={labels[labelKey]} />
            ))}
        </Fragment>
    );
});
const LabelRow = (props) => {
    return (
        <ComponentErrorBoundary componentErrorMessage={'Error Displaying LabelRow'}>
            <Component {...props} />
        </ComponentErrorBoundary>
    );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
    setEditTeam,
})(LabelRow);
